"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _domainless = require("./domainless");
Object.keys(_domainless).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _domainless[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _domainless[key];
    }
  });
});
var _patterns = require("./patterns");
Object.keys(_patterns).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _patterns[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _patterns[key];
    }
  });
});